module.exports = __webpack_public_path__ + "e3199af13b8f7ef158b2a9f9b5ffef27.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/korolev_bold-webfont.woff2
// module id = vxLn
// module chunks = 0